import React from 'react';
import { Button, Typography, Box } from '@mui/material';

export default function TenantNotFound() {
  function handleGetUrlClick() {
    window.location.href = `${
      window.location.protocol
    }//app.${window.location.host
      .split('.')
      .slice(1)
      .join('.')}/login`;
  }

  return (
    <React.Fragment>
      <Typography variant="h1">Damstra Forms URL doesn’t exist</Typography>
      <Typography variant="body1" sx={{ mt: 3 }}>
        Looks like you’ve entered an address that doesn’t exist.
      </Typography>
      <Typography variant="body1" sx={{ mt: 3 }}>
        If you’re trying to log in to Damstra Forms, you can use the button
        below to get the right URL.
      </Typography>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
        <Button variant="contained" color="primary" onClick={handleGetUrlClick}>
          Get your Damstra Forms URL
        </Button>
      </Box>
    </React.Fragment>
  );
}
